import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { StepIndicatorService, PageLoaderService } from './../../../../lib/ng2-sapmp/src/ui-components';
import { UtilityService, AdobeAnalyticsService } from './../../../../lib/ng2-sapmp/src/providers';
import { SendSMSService } from './../send-sms.service';
import { FanModel, CtnModel } from './../../../models';
import { MessageModel } from './../models/smsMessage.model';
import { ENV } from 'config';

declare var ENV_VAR: any;

@Component({
  templateUrl: './select-accounts.component.html',
  styleUrls: ['./select-accounts.component.scss'],
  providers: [AdobeAnalyticsService],
  encapsulation: ViewEncapsulation.None
})

export class SelectAccountComponent implements OnInit {
  public pageJson: any;
  public selectedList: any;
  public inputList: any;
  private savedMessage: MessageModel;

  constructor(private messageService: SendSMSService,
    private stepIndicator: StepIndicatorService,
    private utilities: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: PageLoaderService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private utilityService: UtilityService
    ) {
    this.savedMessage = this.messageService.getMessageModel();
    this.spinner.setPageLoaderStatus(false);
    if (!this.savedMessage.message.length) {
      this.router.navigate(['message'], { relativeTo: this.route.parent });
      return;
    }
    const accountType = this.savedMessage.accountType;
    this.stepIndicator.setCurrentStep('account');
    this.stepIndicator.setVisibility(true);
   // messageService.getPageJson().subscribe(json => {
      this.pageJson = this.route.snapshot.data.pageData.sendMessagemessage;
      this.pageJson = this.pageJson['selectAccountsJson'][accountType];
     // if (json) {
        //this.pageJson = json['selectAccountsJson'][accountType];
        this.pageJson.accountType = accountType;
        this.pageJson.onSearch = false;
        this.selectedList = [];

        if (accountType === 'allFans') {
          this.getAllFan();
          this.spinner.setPageLoaderStatus(true);
        } else {
          this.getCtnList();
        }
      //}
    //});
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.messageService.createPageLoadProperties('ACCOUNTS', 'Accounts');
  }


  getAllFan() {
    this.inputList = this.savedMessage.fanList;
    if(this.inputList && this.inputList.length>0){
      this.inputList = this.inputList.filter((value, index, self) =>
      index === self.findIndex((item) => (
        item.fanId === value.fanId
      ))
    )
    }

    this.pageJson.gridOptions = this.messageService.createGridOptions(this.inputList, this.pageJson.columnDefinitions, 'allFans', 2);
    this.selectedList = this.messageService.filterSelected(this.inputList);
  }

  getCtnList() {
    const fan = this.savedMessage.selectedFan.fanId;
    this.inputList = this.savedMessage.ctnList || [];
    let sessionId = sessionStorage.getItem("sessionId");

    this.pageJson.selectedFan = this.pageJson.fanSelectionStatus.replace('<fanId>', fan);
    if (!this.inputList.length) {
      //this.messageService.getCtnList(fan).subscribe(resObj => {
      this.messageService.getGroupDevicesData(fan, sessionId).subscribe(resObj => {
      this.inputList = resObj.list;
        this.savedMessage.ctnList = this.inputList;
        this.createCtnOptions(true);
      }, (err) => {
        this.spinner.setPageLoaderStatus(true);
        this.messageService.setPageError(this.pageJson.error);
      });
    } else {
      this.createCtnOptions(false);
    }
  }

  createCtnOptions(defaultLoad: boolean) {
    if (this.pageJson.accountType === 'allCTN') {
      if (defaultLoad) {
        this.inputList.filter(item => {
          item.selected = false;
        });
      } else {
        this.inputList = this.messageService.toggleSelect(this.inputList);
      }
      this.selectedList = this.messageService.filterSelected(this.messageService.toggleSelect(JSON.parse(JSON.stringify(this.inputList))));
      this.pageJson.gridHeader = this.pageJson.viewAllGridHeading;
    } else {
      this.selectedList = this.messageService.filterSelected(this.inputList);
      this.pageJson.heading = this.pageJson.viewAllHeading;
    }
    this.pageJson.gridFooter = this.pageJson.gridFooterDescription.replace('<total>', this.inputList.length);
    this.pageJson.gridOptions = this.messageService.createGridOptions(this.inputList, this.pageJson.columnDefinitions,
      this.pageJson.accountType, 2);
    this.spinner.setPageLoaderStatus(true);
  }

  onSelectChange(e: any, accountType: string) {
    this.selectedList = this.messageService.filterSelected(this.inputList);
    if (accountType === 'allCTN') {
      this.selectedList = this.messageService.filterSelected(this.messageService.toggleSelect(JSON.parse(JSON.stringify(this.inputList))));
    }
  }

  searchList = (searchObj: any) => {
    const clearSearch = searchObj.search;
    const results = searchObj.results.length;
    if (this.pageJson.accountType !== 'allFans') {
      if (this.pageJson.accountType === 'allCTN') {
        this.pageJson.gridHeader = (clearSearch || !results) ? this.pageJson.viewAllGridHeading : this.pageJson.searchGridHeading;
      } else {
        this.pageJson.heading = clearSearch ? this.pageJson.viewAllHeading :  this.pageJson.searchHeading;
      }
      this.pageJson.onSearch = !clearSearch;
      this.pageJson.results = results ? true : false;
    }
  }

  next = () => {
    this.adobeAnalyticsService.createAdobeEventProperties('SMS', 'SUCCESS', 'formSubmit',
    'BC_Device_SMS_Select_FAN_Account_Submit', 'success', 'Success_Admit', 'continue', 'Body', '/businessconsole/sendMessage/review');
    if (this.pageJson.accountType === 'allFans') {
      this.savedMessage.fanList = this.inputList;
    } else {
      if (this.pageJson.accountType === 'allCTN') {
        this.inputList = this.messageService.toggleSelect(JSON.parse(JSON.stringify(this.inputList)));
      }
      this.savedMessage.ctnList = this.inputList;
    }

    // Adobe Analytics Success Type Starts
    this.adobeAnalyticsService.createAdobeEventProperties('SMS', 'SUCCESS', 'formResponse',
    'BC_Device_SMS_Select_FAN_Account_Submit', 'success', 'Success_Admit', 'continue', 'Body', '/businessconsole/sendMessage/review');
    // End
    // Update the output Model
    this.messageService.setMessageModel(this.savedMessage);
    this.router.navigate(['review'], { relativeTo: this.route.parent });
  }

  back(route) {
    this.messageService.setPageError('');
    this.router.navigate([route], { relativeTo: this.route.parent });
  }

}
